var map = {
	"./-03_2x.jpg": 75,
	"./00@2x.png": 76,
	"./00_2x.jpg": 77,
	"./01@2x.png": 78,
	"./01_2x.jpg": 79,
	"./02@2x.png": 80,
	"./02_2x.jpg": 13,
	"./03_2x.jpg": 14,
	"./04_2x.jpg": 15,
	"./05_2x.jpg": 16,
	"./06_2x.jpg": 17,
	"./07_2x.jpg": 81,
	"./08_2x.jpg": 82,
	"./09_2x.jpg": 83,
	"./10_2x.jpg": 84,
	"./11_2x.jpg": 18,
	"./12_2x.jpg": 19,
	"./GLD-LF-IM-Black.jpg": 85,
	"./GLD-MF-IM-Black.jpg": 86,
	"./GPO-LF-granulates.jpg": 87,
	"./GPP-HF-GREY-PLUS.jpg": 88,
	"./GPP-HF.jpg": 89,
	"./GPP-LF.jpg": 90,
	"./GPP-MF.jpg": 91,
	"./GRANULO_HOVER_PE@2x.jpg": 92,
	"./I2U1-exblack.png": 93,
	"./I2U1@2x.jpg": 94,
	"./I3U1@2x.jpg": 95,
	"./I5U0-n.png": 96,
	"./I5U0@2x.jpg": 97,
	"./I5U1-lightgray.png": 98,
	"./I5U1.png": 99,
	"./I7M2-grey.png": 100,
	"./I7M2@2x.jpg": 101,
	"./I7U1.png": 102,
	"./IMG_3088_scaglie2.png": 103,
	"./M2M1.png": 104,
	"./M3M2.png": 105,
	"./MyReplast-GHD-EX-BLACK-8010.jpg": 106,
	"./MyReplast-GHD-EX-BLACK.jpg": 107,
	"./MyReplast-GHD-EX-NMB.jpg": 108,
	"./MyReplast-GHD-IM.jpg": 109,
	"./MyReplast-GPO-LF.jpg": 110,
	"./MyReplast-GPO-MF.jpg": 111,
	"./MyReplast-GPP-HF.jpg": 112,
	"./MyReplast-GPP-LF.jpg": 113,
	"./MyReplast-GPP-MF.jpg": 114,
	"./MyReplast-GPP-SF.jpg": 115,
	"./MyReplast-GPP-UF.jpg": 116,
	"./MyReplast-GPP-VF.jpg": 117,
	"./News-Fiera.jpg": 118,
	"./SCAGLIE_HOVER_PP@2x.jpg": 119,
	"./Senza-titolo-1.jpg": 120,
	"./android-icon-144x144.png": 121,
	"./android-icon-192x192.png": 122,
	"./android-icon-36x36.png": 123,
	"./android-icon-48x48.png": 124,
	"./android-icon-72x72.png": 125,
	"./android-icon-96x96.png": 126,
	"./apple-icon-114x114.png": 127,
	"./apple-icon-120x120.png": 128,
	"./apple-icon-144x144.png": 129,
	"./apple-icon-152x152.png": 130,
	"./apple-icon-180x180.png": 131,
	"./apple-icon-57x57.png": 132,
	"./apple-icon-60x60.png": 133,
	"./apple-icon-72x72.png": 134,
	"./apple-icon-76x76.png": 135,
	"./apple-icon-precomposed.png": 136,
	"./apple-icon.png": 137,
	"./apple-touch-icon-114x114.png": 138,
	"./apple-touch-icon-120x120.png": 139,
	"./apple-touch-icon-144x144.png": 140,
	"./apple-touch-icon-152x152.png": 141,
	"./apple-touch-icon-57x57.png": 142,
	"./apple-touch-icon-60x60.png": 143,
	"./apple-touch-icon-72x72.png": 144,
	"./apple-touch-icon-76x76.png": 145,
	"./applications.png": 20,
	"./aprile-1.jpg": 146,
	"./aprile-2.jpg": 147,
	"./aprile-25.jpg": 148,
	"./aprile-3.jpg": 149,
	"./arrow-back.png": 150,
	"./arrow-back@2x.png": 21,
	"./arrow-footer-positive.png": 151,
	"./arrow-footer-positive@2x.png": 22,
	"./arrow-footer.png": 152,
	"./arrow-footer@2x.png": 153,
	"./arrow-next.jpg": 154,
	"./arrow-next@2x.jpg": 155,
	"./arrow-next@2x.png": 23,
	"./arrow-prev.jpg": 156,
	"./arrow-prev@2x.jpg": 157,
	"./arrow-prev@2x.png": 24,
	"./arrow-slide-next.png": 158,
	"./arrow-slide-next@2x.png": 25,
	"./arrow-slide-prev.png": 159,
	"./arrow-slide-prev@2x.png": 26,
	"./arrow_01@2x.png": 160,
	"./arrow_lenguage@2x.png": 161,
	"./arrow_product@2x.png": 162,
	"./beads.jpg": 163,
	"./beads@2x.jpg": 164,
	"./car_prod-1_2x.jpg": 165,
	"./car_prod-2_2x.jpg": 166,
	"./car_prod-3_2x.jpg": 167,
	"./caracol-large-2.jpg": 168,
	"./caracol-large.jpg": 169,
	"./caracol-preview.jpg": 170,
	"./code.txt": 171,
	"./conip.png": 27,
	"./distretto-news-large.jpg": 172,
	"./distretto-news-preview.jpg": 173,
	"./download-icon.png": 174,
	"./download-icon@2x.png": 28,
	"./download@2x.png": 29,
	"./ecomondo-2024.png": 175,
	"./ecomondo-novembre.jpeg": 176,
	"./ecomondo-novembre.jpg": 177,
	"./ecomondo.png": 178,
	"./ecomondo_news-cover.jpg": 179,
	"./ecomondo_news-foto-1.jpg": 180,
	"./ecomondo_news-foto-2.jpg": 181,
	"./ecomondo_news-foto-3.jpg": 182,
	"./ecomondo_news-foto-4.jpg": 183,
	"./ecomondo_news-foto-5.jpg": 184,
	"./empty-col.png": 30,
	"./favicon-128.png": 185,
	"./favicon-16x16.png": 186,
	"./favicon-196x196.png": 187,
	"./favicon-32x32.png": 188,
	"./favicon-96x96.png": 189,
	"./favicon.ico": 190,
	"./fax.png": 191,
	"./fax@2x.png": 31,
	"./flakes.jpg": 192,
	"./flakes@2x.jpg": 193,
	"./footer-logo-maire.png": 32,
	"./footer-logo-next.png": 33,
	"./granuli_pe-img@2x.jpg": 194,
	"./granuli_pe@2x.jpg": 195,
	"./granuli_pp-img@2x.jpg": 196,
	"./granuli_pp@2x.jpg": 197,
	"./grigio.jpg": 198,
	"./home-01.jpg": 199,
	"./huffpost.jpg": 200,
	"./i4t2.png": 201,
	"./i6u1.png": 202,
	"./iStock-1028462780.png": 203,
	"./iStock-1066736656.png": 204,
	"./icon-in.png": 205,
	"./icon-in@2x.png": 206,
	"./icon-linkedin@2x.png": 207,
	"./icon-tw.png": 208,
	"./icon-tw@2x.png": 209,
	"./icon-twitter@2x.png": 210,
	"./img_pe@2x.jpg": 211,
	"./img_pp@2x.jpg": 212,
	"./industriaitaliana.jpg": 213,
	"./inner-accordion.jpg": 214,
	"./inner-accordion@2x.jpg": 215,
	"./iubenda-pref.svg": 34,
	"./june-24-1.jpg": 216,
	"./june-24-2.jpg": 217,
	"./june-24-3.jpg": 218,
	"./june-24-4.jpg": 219,
	"./june-24-cover.jpg": 220,
	"./lf-bm.jpg": 221,
	"./lf-im-scaglie.jpg": 222,
	"./logo-header.png": 223,
	"./logo-header@2x.png": 35,
	"./logo-pre.jpg": 36,
	"./m4u1.png": 224,
	"./mf-im.jpg": 225,
	"./ms-icon-144x144.png": 226,
	"./ms-icon-150x150.png": 227,
	"./ms-icon-310x310.png": 228,
	"./ms-icon-70x70.png": 229,
	"./mstile-144x144.png": 230,
	"./mstile-150x150.png": 231,
	"./mstile-310x150.png": 232,
	"./mstile-310x310.png": 233,
	"./mstile-70x70.png": 234,
	"./multi-lang-arrow-down.svg": 235,
	"./myreplast-christmas.png": 236,
	"./news-01.jpg": 237,
	"./news-image-01.jpg": 238,
	"./news-image-01@2x.jpg": 239,
	"./nextchem.png": 240,
	"./our-tech-hero.jpg": 241,
	"./phone.png": 242,
	"./phone@2x.png": 37,
	"./plastic-streaming.jpg": 243,
	"./prs-banner.jpg": 244,
	"./prs-europe-large.jpg": 245,
	"./prs-europe-preview.jpg": 246,
	"./prs-preview.jpg": 247,
	"./prs2023.png": 248,
	"./prs2024.png": 249,
	"./recyclass.png": 38,
	"./scaglie-su-nastro-nw.jpg": 250,
	"./scaglie-su-nastro-nw2.jpg": 251,
	"./scaglie-su-nastro.JPG": 252,
	"./scaglie_pe@2x.jpg": 253,
	"./scaglie_pp@2x.jpg": 254,
	"./second-life-01-eng.jpg": 255,
	"./second-life-01-ita.jpg": 256,
	"./second-life-02-eng.jpg": 257,
	"./second-life-02-ita.jpg": 258,
	"./section-image-01.jpg": 259,
	"./section-image-01@2x.jpg": 260,
	"./section-image-02.jpg": 261,
	"./section-image-02@2x.jpg": 262,
	"./slider-01.jpg": 263,
	"./slider-01@2x.jpg": 264,
	"./slider-02.jpg": 265,
	"./slider-03.jpg": 266,
	"./slider-03@2x.jpg": 267,
	"./slider-04.jpg": 268,
	"./slider-04@2x.jpg": 269,
	"./slider-05.jpg": 270,
	"./slider-05@2x.jpg": 271,
	"./slider-fabbrica.jpg": 39,
	"./slider-lab.jpg": 40,
	"./webinar.jpg": 272,
	"./world-expo-large.jpg": 273,
	"./world-expo-preview.png": 274,
	"./worldexpo-1.jpg": 275,
	"./worldexpo-2.jpg": 276,
	"./worldexpo-preview.png": 277
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = 3
// module chunks = 0